// extracted by mini-css-extract-plugin
export default {"layoutContainer":"Layout_layoutContainer__VQbPW","mainContent":"Layout_mainContent__o8xLM"};